<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white;">
            <br />
            <div class="col-sm-12 col-xs-12">
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>วันที่เริ่มผลิต</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <date-picker
                                v-model="form.start_date"
                                type="date"
                                :format="changeFormat"
                                :lang="lang"
                                class="w-50"
                                placeholder="วันที่ผลิต" >
                        </date-picker>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>เวลาที่เริ่มผลิต</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="time" class="form-control w-50" v-model="form.start_time"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row style="padding-bottom: 20px">
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>กะ เริ่มต้น</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <b-form-select
                                v-model="form.work_start"
                                class="col-sm-6"
                                :options="optionShift">
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-bottom: 20px">
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>กลุ่ม</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <b-form-select
                                v-model="form.group_id"
                                class="col-sm-6"
                                :options="Group">
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>เครื่อง</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                            v-model="form.machine"
                            class="w-50"
                            :show-labels="false"
                            :options="optionMachine"
                            label="name"
                            placeholder="เลือกเครื่องผลิต"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                                v-model="form.sheet"
                                class="w-50"
                                :show-labels="false"
                                :options="optionSheet"
                                :custom-label="sheetCodeWithName"
                                placeholder="เลือกชีท"
                                @input="setCodeSheet(form.sheet)"
                                track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>รหัสชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input
                            type="text"
                            class="form-control col-sm-6"
                            placeholder="รหัสชีท"
                            disabled
                            v-model="form.sheet_code"/>
                    </b-col>
                </b-row>
                <br />
                <b-row v-if="form.sheet">
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>รายละเอียดชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <div class="border col-sm-6">
                            ยาว :{{form.sheet.length ? form.sheet.length : "-"}} <br>
                            กว้าง :{{form.sheet.width ? form.sheet.width : "-"}} <br>
                            น้ำหนัก :{{form.sheet.weight ? form.sheet.weight : "-"}} <br>
                            เส้นผ่านศูนย์กลาง : {{form.sheet.diameter ? form.sheet.diameter : "-"}} <br>
                            ความหนา : {{form.sheet.thickness ? form.sheet.thickness : "-"}} <br>
                            ขอบ : {{form.sheet.border ? form.sheet.border : "-"}} <br>
                        </div>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>จำนวน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12 form-inline">
                        <input
                                v-model="form.quantity"
                                placeholder="ม้วน"
                                type="number"
                                class="form-control col-sm-6"/>
                        &nbsp;
                        <span>ม้วน</span>
                    </b-col>
                </b-row>
                <br/>
                <!--<b-row>-->
                <!--<b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>วันที่สิ้นสุดการผลิต</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12">-->
                <!--<datepicker placeholder="ไม่ระบุ" :bootstrap-styling="true"-->
                <!--class="col-sm-6"-->
                <!--v-model="form.end_date">-->
                <!--</datepicker>-->
                <!--<br />-->
                <!--</b-col>-->
                <!--</b-row>-->
                <!--<b-row v-if="form.end_date">-->
                    <!--<b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                        <!--<label>เวลาที่สิ้นสุดการผลิต</label>-->
                    <!--</b-col>-->
                    <!--<b-col sm="6" class="col-sm-6 col-xs-12" style="margin-left: 15px">-->
                        <!--<input type="time" class="form-control col-sm-6" v-model="form.end_time"/>-->
                        <!--<br/>-->
                    <!--</b-col>-->
                <!--</b-row>-->
                <!--<b-row v-if="form.end_date" style="padding-bottom: 20px">-->
                    <!--<b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                        <!--<label>กะ สิ้นสุด</label>-->
                    <!--</b-col>-->
                    <!--<b-col sm="6" class="col-sm-6 col-xs-12" style="margin-left: 15px">-->
                        <!--<b-form-select-->
                            <!--v-model="form.work_end"-->
                            <!--class="col-sm-6"-->
                            <!--:options="optionShift">-->
                        <!--</b-form-select>-->
                    <!--</b-col>-->
                <!--</b-row>-->
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>เม็ด</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                                v-model="form.grain"
                                class="w-50"
                                :show-labels="false"
                                :options="optionMaterial"
                                label="name"
                                placeholder="เลือกเม็ดในการผลิต"
                                track-by="id">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>เก่า</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12 form-inline">
                        <input type="text" class="form-control col-sm-6"
                               v-model="form.grain_old"/>
                        &nbsp;
                        <span>กก.</span>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ใหม่</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12 form-inline">
                        <input type="text" class="form-control col-sm-6"
                               v-model="form.grain_new"/>
                        &nbsp;
                        <span>กก.</span>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>แป้ง</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12 form-inline">
                        <input type="text" class="form-control col-sm-6"
                               v-model="form.flour"/>
                        &nbsp;
                        <span>กก.</span>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>หมายเหตุ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <textarea
                            v-model="form.reason"
                            class="form-control col-sm-6"></textarea>
                    </b-col>
                </b-row>
                <br />
                <template v-if="this.id!=null">
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ปัญหาการผลิต</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <textarea
                                v-model="form.problem"
                                class="form-control col-sm-6">

                        </textarea>
                    </b-col>
                </b-row>
                </template>
                <br />
            </div>
            <div class="col text-center">
                <b-button variant="success"
                          @click="saveSheetReport">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </b-button>
                &nbsp;&nbsp;
                <b-button class="btn btn-outline-secondary"
                          @click="goToSheetReportList">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </b-button>
                &nbsp;&nbsp;
                <button v-if="id"
                        type="button"
                        class="btn btn-danger"
                        @click="showModalDelete">
                    <icon name="trash-alt" style="width: 25px"></icon>
                    ลบ
                </button>
            </div>
            <br />
        </div>
        <!-- ----Modal Delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                        type="button"
                        class="btn btn-success"
                        @click="deleteSheetReport">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert-primary">{{optionMaterial.length}}</pre>-->
    </div>
</template>

<script>
import HeaderTitle from "../../HeaderTitle";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import format from 'date-fns/format'
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    components: { HeaderTitle, Multiselect,DatePicker },
    name: "sheet-report-information",
    props: {
        id: { default: null }
    },
    data() {
        return {
            optionMaterial : [],
            items: [
                {
                    text: "รายงานการผลิตชีท",
                    to: { name: "sheet-report" }
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            Group : [
                {value : null , text: "กรุณาเลือกกลุ่ม"},
                {value : 1 , text: "A"},
                {value : 2 , text: "B"}
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/'+year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        console.log(this.id);
        if (!this.id) {
            this.$store.dispatch("ReportSheet/clearFormData");
        }
        this.$store.dispatch("Machine/getMachineSheet");
        this.$store.dispatch("Sheet/getAll");
        this.$store.dispatch('Common/setShiftWork');
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ReportSheet.Form;
            },
            optionMachine: state => {
                return state.Machine.machine_sheet;
            },
            optionSheet:state=>{
                return state.Sheet.sheet_all;
            },
            user: state => {
                return state.Auth.user;
            },
            optionShift: state => {
                return [
                    {
                        value: null,
                        text: "กรุณาเลือกกะ"
                    },
                    ...state.Common.shift_work.filter(data=>data.id != 4).map(shift => ({
                        value: shift.id,
                        text: shift.name
                    }))
                ];
            },
        }),
    },
    methods: {
        showModalDelete() {
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        getMaterialAll(){
            this.$store.dispatch("Material/getAll").then(res=>{
                this.optionMaterial = res.filter(material=>material.type == 3)
            });
        },
        saveSheetReport() {
            if (!this.form.machine) {
                alert("กรุณาเลือกเครื่อง");
            }
            else if(!this.form.sheet){
                alert("กรุณาเลือกชีทที่ผลิต")
            }
            else if(this.form.quantity < 0){
                alert("กรุณาใส่จำนวนให้ถูกต้อง")
            }
            else if(!this.form.group_id){
                alert("กรุณาเลือกกลุ่ม")
            }
            else {
                if(this.form.grain){
                    this.form.grain_id = this.form.grain.id;
                }
                if(this.form.start_date){
                    this.form.start_date = moment(this.form.start_date).format("YYYY-MM-DD");
                }
                if(this.form.end_date){
                    this.form.end_date = moment(this.form.end_date).format("YYYY-MM-DD");
                }
                this.form.user = this.user.name;
                return this.$store.dispatch("ReportSheet/save",this.id).then(() => {
                    this.goToSheetReportList();
                });
            }
        },
        deleteSheetReport() {
            this.$store.dispatch("ReportSheet/delete", this.id).then(() => {
                this.hideModalDelete();
                this.goToSheetReportList();
            });
        },
        goToSheetReportList() {
            this.$router.push({
                name: "sheet-report"
            });
        },
        setCodeSheet(data){
            if(data){
                this.form.sheet_code = data.code;
            }else{
                this.form.sheet_code = ""
            }
        },
        sheetCodeWithName ({ code, name }) {
            return `${name} - ${code}`
        },
    }
};
</script>

<style scoped>
    .form-button {
        /*margin-left: 20%;*/
        display: flex;
        padding: 0;
    }
</style>
